import * as RTooltip from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

/**
 * Top-level provider — must wrap the application root once.
 */
export const TooltipProvider = RTooltip.Provider;

export interface TooltipProps {
  children: ReactNode;
  content: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
  contentClassName?: string;
}

export function Tooltip({
  children,
  content,
  side = "top",
  align = "center",
  delayDuration,
  contentClassName,
}: TooltipProps): JSX.Element {
  return (
    <RTooltip.Root delayDuration={delayDuration}>
      <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
      <RTooltip.Portal>
        <RTooltip.Content
          className={contentClassName ?? "ds-tooltip__content"}
          side={side}
          align={align}
          sideOffset={6}
        >
          {content}
          <RTooltip.Arrow className="ds-tooltip__arrow" />
        </RTooltip.Content>
      </RTooltip.Portal>
    </RTooltip.Root>
  );
}
